import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import axios from "axios";
import moment from "moment";
import { FiEye, FiEyeOff } from "react-icons/fi";

import {
  CustomFieldLevelLoader,
  decruptCipherString,
  decruptCipherJson,
} from "./utils/CommonLibrary";

import { encryptData } from "./utils/Utils";

function LoginPage() {
  const [url, setUrl] = useState("");
  const [loading, showLoading] = useState(true);
  const [emailLoading, setEmailLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      axios
        .post(process.env.REACT_APP_BASE_URL + "sso/login", {})
        .then(function (response) {
          if (response.data.code == 200) {
            setUrl((response.data.data.link));
            console.log('response.data.data.link: ', (response.data.data.link));
            showLoading(false);
          } else {
            alert("Something went wrong");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    fetchData();
  }, []);

  /* -----------------------------
     SSO LOGIN
  ------------------------------*/

  const redirectUrl = () => {
    localStorage.setItem("preLogin", encryptData("Yes"));
    showLoading(true);
    window.location.href = url;
  };

  /* -----------------------------
     EMAIL LOGIN
  ------------------------------*/

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.email) newErrors.email = "Email required";
    if (!formData.password) newErrors.password = "Password required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setEmailLoading(true);

    try {
      const payloadData = {
        email: formData.email,
        password: formData.password,
      };

      const response = await axios.post(
        process.env.REACT_APP_BASE_URL + "sso/login_email",
        payloadData,
      );

      if (response.data.code == 200) {
        let loginData = decruptCipherJson(response.data.data);

        const redirectUrl = decruptCipherString(loginData.data.redirectUrl);

        localStorage.setItem("uid", loginData.data.userAdminId);
        localStorage.setItem("user", loginData.data.username);
        localStorage.setItem("authToken", loginData.data.verificationToken);
        localStorage.setItem("tabs", loginData.data.tabs);
        localStorage.setItem("pagesList", loginData.data.pagesList);
        localStorage.setItem("dashboard", loginData.data.dashboard);
        localStorage.setItem("accesslevel", loginData.data.accesslevel);
        localStorage.setItem("cnId", loginData.data.cnId);
        localStorage.setItem("adminId", loginData.data.userAdminId);

        const selectedDates = decruptCipherJson(loginData.data.selectedDates);

        if (selectedDates) {
          localStorage.setItem(
            "selectedDates",
            encryptData(
              JSON.stringify([
                moment(selectedDates.startDate).toDate(),
                moment(selectedDates.endDate).toDate(),
                moment(selectedDates.ytdStartDate).toDate(),
                moment(selectedDates.ytdEndDate).toDate(),
              ]),
            ),
          );
        }

        window.location.href = redirectUrl;
      } else {
        alert("Invalid credentials");
      }
    } catch (error) {
      console.log(error);
      alert("Login failed");
    }

    setEmailLoading(false);
  };

  return (
    <>
      <section className="LoginPage">
        <div className="card-login tw-p-5">
          <div className="card-body">
            <div className="container-fluid">
              <div className="row align-items-center">
                {/* LEFT SIDE */}

                  <div className="">
                    <img
                      src="https://storecdn.goqii.com/media/store-img/goqii-logo_store.png"
                      className="logo-goqii"
                      alt=""
                    />
                  </div>
                <div className="col-md-6 ps-md-0 pe-md-5 d-flex flex-column justify-content-center">
                  {/* GOQii logo - small */}

                  {/* Health Engage logo - prominent */}
                  <div className="mb-4 text-center">
                    <img
                      src="https://appcdn.goqii.com/storeimg/80972_1727955999.png"
                      className="logo-he"
                      alt=""
                    />
                  </div>

                  <h2 className="mb-4" style={{ fontSize: "20px", fontWeight: 600, color: "#222" }}>Login</h2>

                  {/* EMAIL LOGIN */}

                  <form onSubmit={handleEmailLogin}>
                    <div className="form-group mb-3">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                      />

                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>

                    <div className="form-group mb-3 position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        className="form-control"
                        value={formData.password}
                        onChange={handleChange}
                      />

                      <span
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#888",
                        }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </span>

                      {errors.password && (
                        <small className="text-danger">{errors.password}</small>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="btn btn-login w-100 mb-3"
                      disabled={emailLoading}
                    >
                      {emailLoading ? "Logging in..." : "Login"}
                    </button>
                  </form>

                  {/* DIVIDER */}

                  <div className="tw-relative text-center mb-3" style={{ color: "#888", fontSize: "13px", letterSpacing: "1px" }}>
                    <div className="tw-absolute tw-top-1/2 tw-z-0 tw-w-full tw-h-0.5 tw-bg-gray-300"></div>
                    <strong className="tw-relative tw-bg-white tw-px-2">OR</strong>
                  </div>

                  {/* SSO LOGIN */}

                  <div className="text-center form-group">
                    {!loading ? (
                      <button
                        type="button"
                        className="btn btn-login tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full"
                        onClick={redirectUrl}
                      >
                        <img
                          src="https://storage.googleapis.com/ksabupatest/2026/03/12/s45hf/m4q34s5hm4.png"
                          style={{ height: "22px" }}
                          alt=""
                        />
                        SSO Sign in
                      </button>
                    ) : (
                      <div className="tw-flex tw-justify-center tw-items-center tw-w-full">
                        <CustomFieldLevelLoader />
                      </div>
                    )}
                  </div>
                </div>

                {/* RIGHT IMAGE */}

                <div className="col-md-6 px-0">
                  <img
                    src="https://appcdn.goqii.com/storeimg/20630_1732785232.jpg"
                    className="login-right-img"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="powered-by mt-2">
          <img
            src="https://appcdn.goqii.com/storeimg/91809_1719235434.png"
            style={{ height: "42px" }}
            className=""
            alt=""
          />
        </div>
      </section>
    </>
  );
}

export default LoginPage;
